import React from "react";
import { BackButton, BlankButton, NextButton } from "components";

export const NextBackButtons = ({ appointment, clear, confirm = "" }) => {
  return (
    <div className="grid grid-cols-2 gap-4 mx-6">
      {appointment?.entryStage === 1 && appointment.stage > 1 ? (
        <BackButton appointment={appointment} />
      ) : appointment?.entryStage === 0 && appointment.stage > 0 ? (
        <BackButton appointment={appointment} />
      ) : (
        <BlankButton />
      )}
      <NextButton appointment={appointment} clear={clear} confirm={confirm} />
    </div>
  );
};
